import React from "react"
import { useIntl } from "react-intl"
import SankeyGraph from "components/Shared/Sankey"
import withVisibility from "components/Shared/Hocs/withVisibility"
import SankeyHeader from "./SankeyHeader"
import { ISankeySwitchingProps } from "./interface"
import { createNodes } from "./utils"
import { formatNumber } from "helpers/numbers"
import "./index.scss"
import { SANKEY_MARGIN, SANKEY_TYPE } from "./constants"
import { ILink } from "components/Shared/Sankey/interface"

const SankeySwitching: React.FC<ISankeySwitchingProps> = ({
	type,
	links,
	colorLeft,
	colorRight,
	totalEarnings,
	dimension = 200,
}) => {
	const intl = useIntl()
	const nodes = createNodes(links, colorLeft, colorRight)
	const getMargin = () => {
		return type === SANKEY_TYPE.LOSSES
			? {
					right: SANKEY_MARGIN.ZERO,
					left: SANKEY_MARGIN.LARGE,
					bottom: SANKEY_MARGIN.SHORT,
			  }
			: {
					right: SANKEY_MARGIN.LARGE,
					left: SANKEY_MARGIN.ZERO,
					bottom: SANKEY_MARGIN.SHORT,
			  }
	}

	const setColor = (link: ILink, nodeColor: string) => {
		return {
			...link,
			startColor: nodeColor,
			endColor: nodeColor,
		}
	}

	const customLinks = links.map((link) => {
		const { target, source } = link
		const id = type === SANKEY_TYPE.LOSSES ? source : target
		const { nodeColor = "" } = nodes.find((node) => node.id === id) || {}
		return setColor(link, nodeColor)
	})

	return (
		<div
			className={`sankey-module sankey-orientation-${type}`}
			data-testid={`sankey-orientation-${type}`}
		>
			<SankeyHeader
				title={intl.formatMessage({
					id: `phronesis.sankey.switching.title.${type}`,
				})}
				sankeyFooter={intl.formatMessage({
					id: `phronesis.sankey.switching.sankey.total-earnings.${type}`,
				})}
				totalEarnings={totalEarnings}
				type={type}
			/>
			<div style={{ height: `${nodes.length * 10 + dimension * 3 + 40}px` }}>
				<SankeyGraph
					links={customLinks}
					nodes={nodes}
					valueFormat={(value) => formatNumber(value, intl)}
					margin={getMargin()}
					labelTextColor={"black"}
				/>
			</div>
		</div>
	)
}

export default withVisibility(SankeySwitching)
